import { useMemo, useState } from "react";
import { geoNaturalEarth1, geoPath } from "d3-geo";
import { feature } from "topojson-client";
import countries from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";
import world from "world-atlas/countries-110m.json";

countries.registerLocale(en);
export const countryName = (cc) => (cc === "ZZ" ? "Unknown" : countries.getName(cc, "en", { select: "alias" }) || cc);

const W = 960;
const H = 500;
const shapes = feature(world, world.objects.countries).features
  .filter((f) => f.properties.name !== "Antarctica")
  .map((f) => ({ ...f, cc: countries.numericToAlpha2(String(f.id).padStart(3, "0")) }));
const projection = geoNaturalEarth1().fitSize([W, H], { type: "FeatureCollection", features: shapes });
const pathGen = geoPath(projection);
const PATHS = shapes.map((f) => ({ cc: f.cc, d: pathGen(f) }));

// Terracotta ramp on sqrt scale so small markets still show up next to Nigeria.
const fillFor = (v, max) => {
  if (!v || !max) return "rgba(255,255,255,0.06)";
  const t = Math.sqrt(v / max);
  return `rgba(226, 114, 62, ${0.18 + 0.82 * t})`;
};

export default function WorldMap({ values, selected, onHover, onSelect }) {
  const [hover, setHover] = useState(null);
  const max = useMemo(() => Math.max(0, ...Object.values(values)), [values]);

  const enter = (cc) => { setHover(cc); onHover?.(cc); };
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto" role="img" aria-label="World map" data-testid="geo-world-map">
      {PATHS.map(({ cc, d }, i) => (
        <path
          key={cc || i}
          d={d}
          fill={fillFor(values[cc], max)}
          stroke={selected === cc ? "#E8B04B" : hover === cc ? "rgba(255,255,255,0.7)" : "rgba(255,255,255,0.14)"}
          strokeWidth={selected === cc || hover === cc ? 1.4 : 0.5}
          className="cursor-pointer transition-[fill] duration-300"
          onMouseEnter={() => enter(cc)}
          onMouseLeave={() => enter(null)}
          onClick={() => cc && onSelect?.(cc === selected ? null : cc)}
          data-testid={cc ? `geo-country-${cc}` : undefined}
        />
      ))}
    </svg>
  );
}
